import { render, staticRenderFns } from "./BaseUserMenu.vue?vue&type=template&id=eed3aad2&"
import script from "./BaseUserMenu.vue?vue&type=script&lang=js&"
export * from "./BaseUserMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports